import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro";
import { components } from "ComponentRenderer.js";
import VectorDesign from "images/Vector1.svg";
import { BellElectricIcon, Megaphone, MegaphoneIcon } from "lucide-react";

const Section = tw.section`bg-gray-300 py-10 mb-0`;
const Container = tw.div`max-w-screen-xl mx-auto`;
const TitleArea = tw.div`text-center items-center justify-center w-full mb-8`;
const Title = tw.h1`text-4xl font-bold text-[#01325b] relative`;
const Line = tw.div`h-px w-16 bg-pink-500 mx-4`;

const CoursesGrid = tw.div`
  flex flex-wrap justify-center items-center gap-6
  w-full max-w-screen-xl mx-auto
`;

const CourseCard = styled.div`
  ${tw`bg-[#0f4640] shadow-md rounded-lg p-3 text-center 
       w-1/2 sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/5
       transition duration-300 hover:(shadow-lg bg-[#0f4640])`}

  a {
    ${tw`text-white font-semibold text-lg no-underline hover:(text-white no-underline)`};
  }
`;

const IconImage = styled.img`
  ${tw`w-30 sm:w-32 mt-3 mb-2`}
`;

export default function CoursesOfferedSection({
  innerPages = components.innerPages,
  imageSrc1 = VectorDesign,
}) {
  return (
    <Section>
      <Container>
        <TitleArea>
          <Title>Courses Offered at CA Vijender Aggarwal Classes</Title>
          <IconImage
            style={{ color: "#fff" }}
            src={imageSrc1}
            alt="vector icon"
          />
        </TitleArea>

        <CoursesGrid>
          <CourseCard>
            <a
              href="https://cavijenderaggarwal.com/products/?data=CA Inter Lectures"
              target="_blank"
              rel="noopener noreferrer"
            >
              CA Intermediate
            </a>
          </CourseCard>
          <CourseCard>
            <a href="/" target="_blank" rel="noopener noreferrer">
              CA-Final <br />
              <span tw="flex items-center justify-center gap-2 mt-2">
                <BellElectricIcon size={20} />
                Coming Soon
              </span>
            </a>
          </CourseCard>
          <CourseCard>
            <a
              href="https://cavijenderaggarwal.com/products/?data=CMA%20Inter%20Lectures"
              target="_blank"
              rel="noopener noreferrer"
            >
              CMA-Intermediate
            </a>
          </CourseCard>
          <CourseCard>
            <a href="/" target="_blank" rel="noopener noreferrer">
              CMA-Final
              <br />
              <span tw="flex items-center justify-center gap-2 mt-2">
                <BellElectricIcon size={20} />
                Coming Soon
              </span>
            </a>
          </CourseCard>
        </CoursesGrid>
      </Container>
    </Section>
  );
}
